export const SubscriptionsIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  ...props
}: any) => (
  <svg {...props} width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g id="vuesax/outline/receipt-2">
      <g id="receipt-2">
        <path
          id="Vector"
          d="M13.0001 24.6458C12.1551 24.6458 11.3317 24.2125 10.7684 23.4542L9.67425 21.9917C9.44675 21.6883 9.14342 21.515 8.81842 21.4933C8.49342 21.4825 8.16842 21.6233 7.90842 21.8942L7.29092 21.3417L7.88675 21.8942C6.32675 23.5625 5.12425 23.4325 4.55008 23.205C3.96508 22.9775 2.97925 22.23 2.97925 19.825V7.62666C2.97925 2.81666 4.36591 1.35416 8.90508 1.35416H17.0951C21.6342 1.35416 23.0209 2.81666 23.0209 7.62666V19.825C23.0209 22.2192 22.0351 22.9667 21.4501 23.205C20.8759 23.4325 19.6842 23.5625 18.1134 21.8942C17.8534 21.6125 17.5284 21.4608 17.1926 21.4933C16.8676 21.515 16.5534 21.6883 16.3259 21.9917L15.2317 23.4542C14.6684 24.2125 13.8451 24.6458 13.0001 24.6458ZM8.75341 19.8575C8.79675 19.8575 8.85091 19.8575 8.89425 19.8575C9.69592 19.9008 10.4542 20.3233 10.9634 21.0058L12.0576 22.4683C12.5884 23.1725 13.4009 23.1725 13.9317 22.4683L15.0259 21.0058C15.5459 20.3233 16.2934 19.9008 17.1059 19.8575C17.9076 19.8142 18.7092 20.15 19.2942 20.7783C20.1176 21.6558 20.6484 21.7642 20.8434 21.6883C21.1034 21.58 21.3851 20.9517 21.3851 19.825V7.62666C21.3851 3.71583 20.7026 2.97916 17.0842 2.97916H8.90508C5.28675 2.97916 4.60425 3.71583 4.60425 7.62666V19.825C4.60425 20.9625 4.88591 21.5908 5.14591 21.6883C5.33008 21.7642 5.87175 21.6558 6.69508 20.7783C7.28008 20.1825 8.00591 19.8575 8.75341 19.8575Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M17.5826 12.7292H11.6243C11.1801 12.7292 10.8118 12.3608 10.8118 11.9167C10.8118 11.4725 11.1801 11.1042 11.6243 11.1042H17.5826C18.0268 11.1042 18.3951 11.4725 18.3951 11.9167C18.3951 12.3608 18.0268 12.7292 17.5826 12.7292Z"
          fill={strokeColor}
        />
        <path
          id="Vector_3"
          d="M17.5826 8.39584H11.6243C11.1801 8.39584 10.8118 8.0275 10.8118 7.58334C10.8118 7.13917 11.1801 6.77084 11.6243 6.77084H17.5826C18.0268 6.77084 18.3951 7.13917 18.3951 7.58334C18.3951 8.0275 18.0268 8.39584 17.5826 8.39584Z"
          fill={strokeColor}
        />
        <path
          id="Vector_4"
          d="M8.4283 8.66667C7.83247 8.66667 7.34497 8.17917 7.34497 7.58333C7.34497 6.9875 7.83247 6.5 8.4283 6.5C9.02414 6.5 9.51164 6.9875 9.51164 7.58333C9.51164 8.17917 9.02414 8.66667 8.4283 8.66667Z"
          fill={strokeColor}
        />
        <path
          id="Vector_5"
          d="M8.4283 13C7.83247 13 7.34497 12.5125 7.34497 11.9167C7.34497 11.3208 7.83247 10.8333 8.4283 10.8333C9.02414 10.8333 9.51164 11.3208 9.51164 11.9167C9.51164 12.5125 9.02414 13 8.4283 13Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
